<div *transloco="let unscopedT">
  <ng-container *ngIf="rowData[col.field] as cell">
    <ng-container *ngIf="cell | isRowCell; else valueCell">
      <mat-icon *ngIf="cell.icon as icon">{{ icon }}</mat-icon>

      <app-status-badge *ngIf="cell.statusBadgeColor as color; else cellContent" [color]="color">
        <span class="wrap">{{
          unscopedT(cell.translationScope + '.' + cell.translationKey, cell.translationObj)
        }}</span>
      </app-status-badge>

      <ng-template #cellContent>
        <span class="wrap" [ngClass]="cell.styleClass">{{
          unscopedT(cell.translationScope + '.' + cell.translationKey, cell.translationObj)
        }}</span>
      </ng-template>
    </ng-container>

    <ng-template #valueCell>
      <ng-container *ngIf="cell | isMoment; else rawCell">
        <span class="wrap">{{ cell | displayTimestamp }}</span>
      </ng-container>
    </ng-template>

    <ng-template #rawCell>
      <span class="wrap">{{ cell }}</span>
    </ng-template>
  </ng-container>
</div>
